import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

const LINKS = [
  { to: "/features", label: "Features" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/standards", label: "Standards" },
  { to: "/pricing", label: "Pricing" },
  { to: "/founding", label: "Founding Cohort" },
];

export default function MarketingNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="marketing-brand-logo" className="flex items-center">
          <img src="/logo-light.png" alt="VividVR" className="h-8 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-0.5">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`marketing-nav-${l.label.toLowerCase().split(" ")[0]}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${
                loc.pathname === l.to ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button variant="ghost" onClick={() => nav(user ? "/dashboard" : "/login")}>{user ? "Dashboard" : "Sign in"}</Button>
          <Button onClick={() => nav(user ? "/generator" : "/register")} className="rounded-full">
            Get started <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </header>
  );
}
